import { cn } from '@/lib/utils'
import {
    NotificationMessage,
    NotificationVisualMessage,
} from '@/service/api/endpoints/notificacoes'
import { ExternalLinkIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    data: NotificationMessage & { seen?: boolean }
}

export default function Notificacao({ data, className, ...props }: IProps) {
    const navigate = useNavigate()

    const notification =
        data.mode === 'silent'
            ? null
            : (data as NotificationVisualMessage & { seen?: boolean })

    if (notification === null) return null

    return (
        <div
            title={notification.onClickUrl}
            className={cn(
                'p-4 rounded-md border bg-card transition-colors',
                {
                    'border-primary hover:bg-primary/10':
                        notification.severity === 'info',
                    'border-success hover:bg-success/10':
                        notification.severity === 'success',
                    'border-warning hover:bg-warning/10':
                        notification.severity === 'warning',
                    'border-error hover:bg-error/10':
                        notification.severity === 'error',
                    'cursor-pointer': !!notification.onClickUrl,
                    'ring-1 ring-primary/40 bg-primary/10': !notification.seen,
                },
                className,
            )}
            onClick={() => {
                if (!notification.onClickUrl) return

                notification.onClickUrl.startsWith('http')
                    ? window.open(notification.onClickUrl, '_blank')
                    : navigate(notification.onClickUrl)
            }}
            {...props}
        >
            <div className="w-full flex justify-between items-center mb-1">
                <div className="flex items-center gap-2">
                    {!notification.seen && (
                        <span
                            className="size-2 rounded-full bg-primary"
                            aria-label="Notificacao nao lida"
                        />
                    )}
                    <span
                        className={cn('text-sm', {
                            'font-bold': !notification.seen,
                            'font-semibold': notification.seen,
                        })}
                    >
                        {notification.title}
                    </span>
                </div>
                {notification.onClickUrl && (
                    <ExternalLinkIcon className="size-4" />
                )}
            </div>
            <p
                className={cn(
                    'text-xs line-clamp-3 overflow-hidden text-ellipsis',
                    {
                        'text-foreground': !notification.seen,
                    },
                )}
                title={notification.message}
            >
                {notification.message}
            </p>
        </div>
    )
}
